module.exports = [
  "$rootScope",
  "$timeout",
  "$window",
  function($rootScope, $timeout, $window) {
    return {
      restrict: "E",
      scope: true,
      replace: true,
      controller: [
        "$scope",
        function($scope) {
          $scope.moveByDaysForm = {
            amount: 1
          };

          function businessDaysAdd(date, days) {
            var i = 0;
            if (days > 0) {
              while (i < days) {
                date.add(1, "days");
                if (date.day() > 0 && date.day() < 6) {
                  i++;
                }
              }
            } else {
              while (i > days) {
                date.subtract(1, "days");
                if (date.day() > 0 && date.day() < 6) {
                  i--;
                }
              }
            }
            return date;
          }

          function getNextWeekday(currentDay) {
            var nextDate = "";

            if (currentDay != "") {
              var lastDate = moment(currentDay, $scope.$root.dateFormat.moment);
              if (lastDate.day() == 5) {
                lastDate.add(3, "days");
              } else {
                lastDate.add(1, "days");
              }

              nextDate = lastDate.format($scope.$root.dateFormat.moment);
            }
            return nextDate;
          }

          $scope.moveByDays = function() {
            $scope.moveByDaysForm.amount = parseInt(
              $scope.moveByDaysForm.amount
            );
            for (var i = $scope.order.dates.length - 1; i >= 0; i--) {
              var dateString = $scope.order.dates[i].delivery_on;
              var date = moment(dateString, $scope.$root.dateFormat.moment);
              date = businessDaysAdd(date, $scope.moveByDaysForm.amount);
              $scope.order.dates[i].delivery_on = date.format(
                $scope.$root.dateFormat.moment
              );
            }
            $scope.moveByDaysForm.amount = 1;
          };

          $scope.removeOrderDate = function(index) {
            $scope.order.dates.splice(index, 1);
          };

          $scope.addOrderDate = function() {
            const hasOrderDates = $scope.order.dates.length > 0;
            const lastDate = $scope.order.dates[$scope.order.dates.length - 1];
            const nextDate = hasOrderDates ?
              {
                delivery_on: getNextWeekday(lastDate.delivery_on),
                nightshift: false,
                load_time: lastDate.load_time ?
                  moment.utc(lastDate.load_time).toDate():
                  undefined,
                quantity: lastDate.quantity,
              } :
              {
                delivery_on: moment().format($scope.$root.dateFormat.moment),
                nightshift: false,
                load_time: undefined,
                quantity: undefined,
              };

            $scope.order.dates.push(nextDate);
          };

          $scope.showTime = function(order_date) {
            order_date.load_time = moment.utc({ hour: 7 }).toDate();
          };

          $scope.resetLoadTime = function(order_date) {
            order_date.load_time = null;
          };
        }
      ],
      templateUrl: "/static/partials/order_dates_editor.html",
      link: function($scope, $element, attrs) {}
    };
  }
];
